const $ = jQuery;

/*
 * stat
 */
let getSavedUserStats = function (options = {apiDomain: '', beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.apiDomain}/web/simulator/stat/user`,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getSavedUserStats error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757
// https://wiki.ncsoft.com/pages/viewpage.action?pageId=305141971 20201017 API path 수정됨

let getClassDefaultStat = function (options = {apiDomain: '', classId: '',  targetLevel: '',beforeSend: null}) { // 2022.01 targetLevel 추가
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.apiDomain}/web/simulator/stat/${options.classId}/default?targetLevel=${options.targetLevel}`,
      contentType: 'application/json',
      dataType: 'json',
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getClassDefaultStat error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let getSavedUserStat = function (options = {apiDomain: '', idx: '', beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.apiDomain}/web/simulator/stat/user/${options.idx}`,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getSavedUserStat error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-POST/web/simulator/stat/user
let saveNewUserStat = function (options = {apiDomain: '', sendData: null, beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'POST',
      url: `${options.apiDomain}/web/simulator/stat/user`,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(options.sendData),
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('saveNewUserStat error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let saveUserStat = function (options = {apiDomain: '', idx: '', sendData: null, beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'PUT',
      url: `${options.apiDomain}/web/simulator/stat/user/${options.idx}`,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(options.sendData),
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('saveUserStat error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let deleteUserStat = function (options = {apiDomain: '', idx: '', beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'DELETE',
      url: `${options.apiDomain}/web/simulator/stat/user/${options.idx}`,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('deleteUserStat error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let calculateStatByLevelUp = function(options = {apiDomain: '', classId: '', level: 1, sendData: null, beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'PUT',
      url: `${options.apiDomain}/web/simulator/stat/class/${options.classId}/level/${options.level}`,
      data: JSON.stringify(options.sendData),
      contentType: 'application/json',
      dataType: 'json',
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('calculateStatByLevelUp error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let calculateStat = function(options = {apiDomain: '', classId: '', sendData: null, beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'PUT',
      url: `${options.apiDomain}/web/simulator/stat/class/${options.classId}`,
      data: JSON.stringify(options.sendData),
      contentType: 'application/json',
      dataType: 'json',
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('calculateStat error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

/*
 * equip
 */
let getStatNoEquips = function(options = {apiDomain: '', sendData: null, beforeSend: null}) { // final_stats 2019.
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'PUT',
      url: `${options.apiDomain}/web/simulator/equip/class/${options.sendData.classId}/final_stats`,
      contentType: 'application/json',
      data: JSON.stringify(options.sendData),
      dataType: 'json',
	  cache: false,
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getStatNoEquips error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};


// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=91226365#WebDev-리니지RWDAPI-My-GET/api/my/characters
let getMyCharacters = function (options = {apiDomain: '', beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.apiDomain}/api/my/characters`,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getMyCharacters error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let getSavedUserEquips = function (options = {apiDomain: '', beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.apiDomain}/web/simulator/equip/user`,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: {withCredentials: true},
      cache: false,
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getSavedUserEquips error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let getSavedUserEquip = function (options = {apiDomain: '', idx: '', beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.apiDomain}/web/simulator/equip/user/${options.idx}`,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getSavedUserEquip error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let getUserStats = function(options = {apiDomain: '', serverId: '', characterName: '', beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.apiDomain}/web/simulator/equip/servers/${options.serverId}/characters/${options.characterName}/stat`,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getUserStats error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let getUserSlotsStatus = function (options = {apiDomain: '', serverId: '', characterName: '', beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.apiDomain}/web/simulator/equip/servers/${options.serverId}/characters/${options.characterName}/slot`,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getUserSlotsStatus error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let getUserEquips = function (options = {apiDomain: '', serverId: '', characterName: '', beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.apiDomain}/web/simulator/equip/servers/${options.serverId}/characters/${options.characterName}/equipments`,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getUserEquips error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// url: `${options.apiDomain}/web/search/equipment`,
// url: `${options.searchApiDomain}/lineage/search/v2/equip`,
let getSearchEquipItems = function (options = {apiDomain: '', sendData: null, beforeSend: null}) {
  // console.log('getSearchEquipItems() JSON.stringify(options.sendData) : ', JSON.stringify(options.sendData) , 'options.sendData : ', options.sendData );
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.searchApiDomain}/lineage/search/v2/equip`,
      contentType: 'application/json',
      data: options.sendData, // JSON.stringify(options.sendData), post -> get
      dataType: 'json',
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getSearchEquipItems() error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let getStatReflectEquips = function (options = {apiDomain: '', sendData: null, beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'PUT',
      url: `${options.apiDomain}/web/simulator/equip/class/${options.sendData.classId}/item`,
      contentType: 'application/json',
      data: JSON.stringify(options.sendData),
      dataType: 'json',
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getStatReflectEquips error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let saveNewEquip = function (options = {apiDomain: '', sendData: null, beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'POST',
      url: `${options.apiDomain}/web/simulator/equip/user`,
      contentType: 'application/json',
      data: JSON.stringify(options.sendData),
      dataType: 'json',
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('saveNewEquip error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-PUT/web/simulator/equip/user/:idx
let saveExistingEquip = function (options = {apiDomain: '', idx: '', sendData: null, beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'PUT',
      url: `${options.apiDomain}/web/simulator/equip/user/${options.idx}`,
      contentType: 'application/json',
      data: JSON.stringify(options.sendData),
      dataType: 'json',
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('saveExistingEquip error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let deleteSavedEquip = function (options = {apiDomain: '', idx: '', beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'DELETE',
      url: `${options.apiDomain}/web/simulator/equip/user/${options.idx}`,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('deleteSavedEquip error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=89740552#WebDev-리니지RWDAPI-MarketPrice-GET/api/marketprice/trade/currentStatisticSummary
let getEquipItemPrice = function (options = {apiDomain: '', beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.apiDomain}/api/marketprice/trade/currentStatisticSummary`,
      contentType: 'application/json',
      dataType: 'json',
      data: options.sendData, // {serverId, itemId, enchant}
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getEquipItemPrice error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=89740552#WebDev-리니지RWDAPI-MarketPrice-GET/api/marketprice/trade/currentStatisticSummary
let getItemStatisticSummary = function (options = {apiDomain: '', sendData: null, beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.apiDomain}/api/marketprice/trade/currentStatisticSummary`,
      contentType: 'application/json',
      dataType: 'json',
      data: options.sendData,
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getItemStatisticSummary error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let getAffectStats = function (options = {apiDomain: '', itemId: '', enchant: '', sendData: null, beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.apiDomain}/web/simulator/equip/items/${options.itemId}/enchant/${options.enchant}/affectStats`,
      contentType: 'application/json',
      dataType: 'json',
      data: options.sendData,
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getAffectStats error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// qna board
// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-GET/web/simulator/stat/article/:articleId/details
let getStatArticleDetails = function (options = {apiDomain: '', articleId: '', beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.apiDomain}/board/simulator/stat/article/${options.articleId}/details`,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getStatArticleDetails error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-GET/web/simulator/stat/article/:articleId/details
let getEquipArticleDetails = function (options = {apiDomain: '', articleId: '', beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.apiDomain}/board/simulator/equip/article/${options.articleId}/details`,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: {withCredentials: true},
      beforeSend: options.beforeSend || null

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getEquipArticleDetails error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let getCommunityCategory = function(options = {apiDomain: '', beforeSend: null}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: `${options.apiDomain}/board/simulator/category.json`,
      contentType: 'application/json',
      dataType: 'json'

    }).done(function( data, textStatus, jqXHR ) {
      resolve(data, textStatus, jqXHR);

    }).fail(function( jqXHR, textStatus, errorThrown) {
      let error = new Error('getCommunityCategory error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

let _orgStats = {};

let setOrgStats = function(options = {data: null}) {
    return _orgStats = options.data;
};

let getOrgStats = function() {
    return _orgStats;
};



export {
  // stat
  getClassDefaultStat,
  saveNewUserStat,
  getSavedUserStats,
  getSavedUserStat,
  saveUserStat,
  deleteUserStat,

  calculateStatByLevelUp,
  calculateStat,

  // equip
  getSavedUserEquips,
  getSavedUserEquip,

  getUserStats,
  getUserSlotsStatus,
  getUserEquips,

  getMyCharacters,
  getSearchEquipItems,

  getStatNoEquips,
  getStatReflectEquips,
  saveNewEquip,
  saveExistingEquip,
  deleteSavedEquip,

  getEquipItemPrice,
  getItemStatisticSummary,
  getAffectStats,

  // qna board
  getStatArticleDetails,
  getEquipArticleDetails,
  getCommunityCategory,

    setOrgStats,
    getOrgStats

};


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/utils/service.js